import { AppModules, PathModules } from '~/services/Permissions';

import { PermissionsState } from '../../slice';

export const pathModuleIsEnabled = (
  module: keyof typeof AppModules,
  permissions: PermissionsState | undefined,
  path?: keyof typeof PathModules,
) => {
  if (path) {
    return permissions?.enabledModules.includes(PathModules[path]);
  }
  return permissions?.enabledModules.includes(AppModules[module]);
};
